import { removeChildren } from './html.js';
import { AmiWatcherCollection } from './watcher.js';

export default function AmiMessageList(parent) {
    var container = <div id="chatList" class="fullWidth" />;
    var isEven = true;
    var idPfx = 'sock_msg_';
    var watchers = new AmiWatcherCollection;
    parent.appendChild(container);

    watchers.define(['nameInsert', 'delete']);

    var reflow = function() {
        isEven = true;
        for(var i = 0; i < container.children.length; ++i) {
            var child = container.children[i];
            child.classList[isEven ? 'remove' : 'add']('rowOdd');
            child.classList[isEven ? 'add' : 'remove']('rowEven');
            isEven = !isEven;
        }
    };

    return {
        add: function(msgInfo) {

            var nameStyle = { color: msgInfo.sender.color };
            if(msgInfo.nameBold) nameStyle.fontWeight = 'bold';
            if(msgInfo.nameItalics) nameStyle.fontStyle = 'italic';
            if(msgInfo.nameUnderline) nameStyle.textDecoration = 'underline';

            var nameBody = msgInfo.sender.username;
            if(msgInfo.sender.isBot())
                nameBody = <span class="botName">{nameBody}</span>;

            var message = <div id={idPfx + msgInfo.id} class={isEven ? 'rowEven' : 'rowOdd'}>
                <span class="date">({msgInfo.created.toLocaleTimeString()})</span>
                {' '}
                <span style={nameStyle} onclick={() => { watchers.call('nameInsert', msgInfo, [msgInfo]); }}>{nameBody}</span>
            </div>;

            if(msgInfo.showColon)
                message.appendChild(<span class="msgColon">:</span>);

            if(msgInfo.isAction) {
                if(msgInfo.bodyText.indexOf("'") !== 0 || (msgInfo.bodyText.match(/\'/g).length % 2) === 0)
                    message.appendChild(document.createTextNode(' '));
            } else {
                message.appendChild(document.createTextNode(' '));
                message.appendChild(<span class="msgBreak"><br /></span>);
            }

            if(msgInfo.isPM) {
                if(msgInfo.pmTargetName)
                    message.appendChild(<i>{AmiStrings.getMenuString('whisperto', msgInfo.pmTargetName)}</i>);
                else
                    message.appendChild(<i>{AmiStrings.getMenuString('whisper')}</i>);
                message.appendChild(document.createTextNode(' '));
            }

            let msgBodyTarget = message;
            if(msgInfo.isAction)
                message.appendChild(msgBodyTarget = <i />);
            msgBodyTarget.insertAdjacentHTML('beforeend', msgInfo.bodyRaw);

            if(msgInfo.canDelete)
                message.appendChild(<a href="javascript:void(0)" title="Delete this message" class="sprite-small sprite-delete"
                    style={{ float: 'right', margin: '2px 0 0 0' }} onclick={() => { watchers.call('delete', msgInfo, [msgInfo]); }} />);

            isEven = !isEven;
            container.appendChild(message);

            return message;
        },
        remove: function(msgId) {
            const elem = document.getElementById(idPfx + msgId);
            if(elem)
                elem.parentNode.removeChild(elem);
            reflow();
        },
        clear: function() {
            removeChildren(container);
            isEven = true;
        },
        reflow: reflow,
        showSideBar: function(type) {
            container.classList[type === 'wide' ? 'add' : 'remove']('wideSideVisible');
            container.classList[type === 'thin' ? 'add' : 'remove']('userListVisible');
            container.classList[type === 'none' ? 'add' : 'remove']('fullWidth');
        },
        scrollToBottom: function() {
            container.scrollTop = container.scrollHeight;
        },
        watch: function(name, watcher) {
            watchers.watch(name, watcher);
        },
        unwatch: function(name, watcher) {
            watchers.unwatch(name, watcher);
        },
    };
};
